/* tslint:disable */
/* eslint-disable */
/**
 * Referentials API
 * API for managing referentials, including countries, civility titles, and nationalities.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CoproRegistryEntryDto,
  CoproRegistryImportStatusDto,
  EnterpriseDto,
  GetReferentialsByKeysCommand,
  GetReferentialsByKeysResponse,
  GlobalReferentialsDto,
  ReferentialKey,
  ReferentialResponseDto,
} from '../models/index';
import {
    CoproRegistryEntryDtoFromJSON,
    CoproRegistryEntryDtoToJSON,
    CoproRegistryImportStatusDtoFromJSON,
    CoproRegistryImportStatusDtoToJSON,
    EnterpriseDtoFromJSON,
    EnterpriseDtoToJSON,
    GetReferentialsByKeysCommandFromJSON,
    GetReferentialsByKeysCommandToJSON,
    GetReferentialsByKeysResponseFromJSON,
    GetReferentialsByKeysResponseToJSON,
    GlobalReferentialsDtoFromJSON,
    GlobalReferentialsDtoToJSON,
    ReferentialKeyFromJSON,
    ReferentialKeyToJSON,
    ReferentialResponseDtoFromJSON,
    ReferentialResponseDtoToJSON,
} from '../models/index';

export interface GetCoproRegistryByRegistrationNumberRequest {
    numeroImmatriculation: string;
}

export interface GetCoproRegistryBySiretRequest {
    siret: string;
    maxResultCount?: number;
}

export interface GetCoproRegistryWithinRadiusRequest {
    longitude: number;
    latitude: number;
    radiusInKm: number;
    maxResultCount?: number;
}

export interface GetEnterpriseBySiretRequest {
    siret: string;
}

export interface GetMultipleReferentialsRequest {
    getReferentialsByKeysCommand: GetReferentialsByKeysCommand;
}

export interface GetReferentialsByKeyRequest {
    referentialKey: ReferentialKey;
}

export interface SearchEnterprisesRequest {
    query: string;
    codePostal?: string;
    maxResultCount?: number;
}

/**
 * 
 */
export class ReferentialsApi extends runtime.BaseAPI {

    /**
     * Registry coproperty by its RNIC registration number
     */
    async getCoproRegistryByRegistrationNumberRaw(requestParameters: GetCoproRegistryByRegistrationNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CoproRegistryEntryDto>> {
        if (requestParameters['numeroImmatriculation'] == null) {
            throw new runtime.RequiredError(
                'numeroImmatriculation',
                'Required parameter "numeroImmatriculation" was null or undefined when calling getCoproRegistryByRegistrationNumber().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['numeroImmatriculation'] != null) {
            queryParameters['numeroImmatriculation'] = requestParameters['numeroImmatriculation'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/referentiel/registre-copropriete/by-immatriculation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CoproRegistryEntryDtoFromJSON(jsonValue));
    }

    /**
     * Registry coproperty by its RNIC registration number
     */
    async getCoproRegistryByRegistrationNumber(requestParameters: GetCoproRegistryByRegistrationNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CoproRegistryEntryDto> {
        const response = await this.getCoproRegistryByRegistrationNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Registry coproperties managed by a legal representative (syndic) SIRET
     */
    async getCoproRegistryBySiretRaw(requestParameters: GetCoproRegistryBySiretRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CoproRegistryEntryDto>>> {
        if (requestParameters['siret'] == null) {
            throw new runtime.RequiredError(
                'siret',
                'Required parameter "siret" was null or undefined when calling getCoproRegistryBySiret().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['siret'] != null) {
            queryParameters['siret'] = requestParameters['siret'];
        }

        if (requestParameters['maxResultCount'] != null) {
            queryParameters['maxResultCount'] = requestParameters['maxResultCount'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/referentiel/registre-copropriete/by-siret-representant`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CoproRegistryEntryDtoFromJSON));
    }

    /**
     * Registry coproperties managed by a legal representative (syndic) SIRET
     */
    async getCoproRegistryBySiret(requestParameters: GetCoproRegistryBySiretRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CoproRegistryEntryDto>> {
        const response = await this.getCoproRegistryBySiretRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Status of the national coproperty registry (RNIC) import
     */
    async getCoproRegistryImportStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CoproRegistryImportStatusDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/referentiel/registre-copropriete/import/statut`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CoproRegistryImportStatusDtoFromJSON(jsonValue));
    }

    /**
     * Status of the national coproperty registry (RNIC) import
     */
    async getCoproRegistryImportStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CoproRegistryImportStatusDto> {
        const response = await this.getCoproRegistryImportStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Registry coproperties within a radius around a point
     */
    async getCoproRegistryWithinRadiusRaw(requestParameters: GetCoproRegistryWithinRadiusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CoproRegistryEntryDto>>> {
        if (requestParameters['longitude'] == null) {
            throw new runtime.RequiredError(
                'longitude',
                'Required parameter "longitude" was null or undefined when calling getCoproRegistryWithinRadius().'
            );
        }

        if (requestParameters['latitude'] == null) {
            throw new runtime.RequiredError(
                'latitude',
                'Required parameter "latitude" was null or undefined when calling getCoproRegistryWithinRadius().'
            );
        }

        if (requestParameters['radiusInKm'] == null) {
            throw new runtime.RequiredError(
                'radiusInKm',
                'Required parameter "radiusInKm" was null or undefined when calling getCoproRegistryWithinRadius().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['longitude'] != null) {
            queryParameters['longitude'] = requestParameters['longitude'];
        }

        if (requestParameters['latitude'] != null) {
            queryParameters['latitude'] = requestParameters['latitude'];
        }

        if (requestParameters['radiusInKm'] != null) {
            queryParameters['radiusInKm'] = requestParameters['radiusInKm'];
        }

        if (requestParameters['maxResultCount'] != null) {
            queryParameters['maxResultCount'] = requestParameters['maxResultCount'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/referentiel/registre-copropriete/within-radius`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CoproRegistryEntryDtoFromJSON));
    }

    /**
     * Registry coproperties within a radius around a point
     */
    async getCoproRegistryWithinRadius(requestParameters: GetCoproRegistryWithinRadiusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CoproRegistryEntryDto>> {
        const response = await this.getCoproRegistryWithinRadiusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Company identity by SIRET (server-side proxy of the public company registry)
     */
    async getEnterpriseBySiretRaw(requestParameters: GetEnterpriseBySiretRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EnterpriseDto>> {
        if (requestParameters['siret'] == null) {
            throw new runtime.RequiredError(
                'siret',
                'Required parameter "siret" was null or undefined when calling getEnterpriseBySiret().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/referentiel/entreprises/{siret}`.replace(`{${"siret"}}`, encodeURIComponent(String(requestParameters['siret']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EnterpriseDtoFromJSON(jsonValue));
    }

    /**
     * Company identity by SIRET (server-side proxy of the public company registry)
     */
    async getEnterpriseBySiret(requestParameters: GetEnterpriseBySiretRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EnterpriseDto> {
        const response = await this.getEnterpriseBySiretRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve multiple referential by keys
     */
    async getMultipleReferentialsRaw(requestParameters: GetMultipleReferentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReferentialsByKeysResponse>> {
        if (requestParameters['getReferentialsByKeysCommand'] == null) {
            throw new runtime.RequiredError(
                'getReferentialsByKeysCommand',
                'Required parameter "getReferentialsByKeysCommand" was null or undefined when calling getMultipleReferentials().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/referentiel/types`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetReferentialsByKeysCommandToJSON(requestParameters['getReferentialsByKeysCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReferentialsByKeysResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve multiple referential by keys
     */
    async getMultipleReferentials(requestParameters: GetMultipleReferentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReferentialsByKeysResponse> {
        const response = await this.getMultipleReferentialsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all the referentials
     */
    async getReferentialsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GlobalReferentialsDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/referentiel/forms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GlobalReferentialsDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve all the referentials
     */
    async getReferentials(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GlobalReferentialsDto> {
        const response = await this.getReferentialsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a referential by key
     */
    async getReferentialsByKeyRaw(requestParameters: GetReferentialsByKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReferentialResponseDto>> {
        if (requestParameters['referentialKey'] == null) {
            throw new runtime.RequiredError(
                'referentialKey',
                'Required parameter "referentialKey" was null or undefined when calling getReferentialsByKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/referentiel/type/{referentialKey}`.replace(`{${"referentialKey"}}`, encodeURIComponent(String(requestParameters['referentialKey']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferentialResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve a referential by key
     */
    async getReferentialsByKey(requestParameters: GetReferentialsByKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReferentialResponseDto> {
        const response = await this.getReferentialsByKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Downloads the daily CSV from data.gouv and replaces the active generation atomically. Runs in the background; poll the status endpoint.
     * Launch the national coproperty registry (RNIC) import
     */
    async launchCoproRegistryImportRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/referentiel/registre-copropriete/import`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Downloads the daily CSV from data.gouv and replaces the active generation atomically. Runs in the background; poll the status endpoint.
     * Launch the national coproperty registry (RNIC) import
     */
    async launchCoproRegistryImport(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.launchCoproRegistryImportRaw(initOverrides);
    }

    /**
     * Search companies by name, optionally restricted to a postal code (server-side proxy of the public company registry)
     */
    async searchEnterprisesRaw(requestParameters: SearchEnterprisesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EnterpriseDto>>> {
        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling searchEnterprises().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['codePostal'] != null) {
            queryParameters['codePostal'] = requestParameters['codePostal'];
        }

        if (requestParameters['maxResultCount'] != null) {
            queryParameters['maxResultCount'] = requestParameters['maxResultCount'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/referentiel/entreprises`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EnterpriseDtoFromJSON));
    }

    /**
     * Search companies by name, optionally restricted to a postal code (server-side proxy of the public company registry)
     */
    async searchEnterprises(requestParameters: SearchEnterprisesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EnterpriseDto>> {
        const response = await this.searchEnterprisesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
